// Site-wide config constants for SEO + Schema.org modules.
import type { Locale } from '@/i18n/routing';

export const SITE = {
  url: process.env.NEXT_PUBLIC_SITE_URL || 'https://cortexit.ru',
  brand: 'Cortex IT',
  email: 'hello@cortexit.ru',
  telegram: 'cortexit',
} as const;

export const OG_LOCALE: Record<Locale, string> = {
  ru: 'ru_RU',
  en: 'en_US',
};

/** Абсолютный URL страницы в нужной локали. Русская живёт в корне, без префикса. */
export function localeUrl(locale: Locale, path = ''): string {
  return `${SITE.url}${locale === 'ru' ? '' : `/${locale}`}${path}`;
}

/** canonical + hreflang для одного и того же пути во всех локалях. */
export function alternatesFor(locale: Locale, path = '') {
  return {
    canonical: localeUrl(locale, path),
    languages: {
      ru: localeUrl('ru', path),
      en: localeUrl('en', path),
      'x-default': localeUrl('ru', path),
    },
  };
}
